import {createSelector} from 'reselect';

import {getUIState} from '../../../ui-selectors';

const getEngagementLeadsState = createSelector([getUIState], (uiState) => uiState.engagementLeads);

const getEngagementLeadsChartState = createSelector(
    [getEngagementLeadsState],
    (engagementLeads) => engagementLeads.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getEngagementLeadsChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getEngagementLeadsChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getEngagementLeadsChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getEngagementLeadsChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);

export const getCurrentReportChartBucketCount = createSelector(
    [getCurrentReportChartData],
    (chartData) => (chartData ? chartData.buckets.length : 1)
);

// List selectors
const getEngagementLeadsListState = createSelector(
    [getEngagementLeadsState],
    (engagementLeads) => engagementLeads.leadsList
);

const getEngagementLeadsSummaryStatsState = createSelector(
    [getEngagementLeadsState],
    (engagementLeads) => engagementLeads.summaryStats
);

export const getListIsLoading = createSelector(
    [getEngagementLeadsListState],
    (listState) => listState.isLoading
);

export const getListIsFirstLoad = createSelector(
    [getEngagementLeadsListState],
    (listState) => listState.isFirstLoad
);

export const getListItems = createSelector(
    [getEngagementLeadsListState],
    (listState) => listState.listItems
);

export const getListMeta = createSelector(
    [getEngagementLeadsListState],
    (listState) => listState.meta
);

export const getListErrorMessage = createSelector(
    [getEngagementLeadsListState],
    (listState) => listState.errorMessage
);

export const getSummaryStats = createSelector(
    [getEngagementLeadsSummaryStatsState],
    (summaryStatsState) => summaryStatsState.stats
);

export const getSummaryStatsIsLoading = createSelector(
    [getEngagementLeadsSummaryStatsState],
    (summaryStatsState) => summaryStatsState.isLoading
);

export type EngagementLeadCounts = {
    chats: number;
    bookings: number;
    quotes: number;
    emails: number;
    calls: number;
    texts: number;
};

const DEFAULT_COUNTS: EngagementLeadCounts = {
    chats: 0,
    bookings: 0,
    quotes: 0,
    emails: 0,
    calls: 0,
    texts: 0,
};

export const getEngagementLeadCounts = createSelector(
    [getListMeta],
    (meta): EngagementLeadCounts => meta?.facets?.engagementLeadCounts || DEFAULT_COUNTS
);
